package one.healthium.meal_plans.tutorial.screen

sealed interface PersonalMealPlanTutorialEvent {
    data class OpenMealPlan(val id: String) : PersonalMealPlanTutorialEvent
}